export default {"src":"/_next/static/media/badge.55ec4276.svg","height":38,"width":30};